/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import axios from 'axios';
import { Button } from '../features/button/index';
import Sidebar from './Sidebar';
import Checkbox from '../Checkbox';
import { TEXT } from '../../locals';
import { API } from '../../api';
import { URL } from '../../url';
import { ERROR_MESSAGES } from '../../error_messages';
import { Push, setDelay, setToken } from '../../util';
import SocialLogin from './SocialLogin';
import { ERROR_TYPES } from '../../errorTypes';

const { SIGN_UP_SIDEBAR } = TEXT.MAIN;

class RegistrationSidebar extends Component {
  constructor(props) {
    super(props);
    this.state = { error: '', disabled: false };
    this.email = React.createRef();
    this.password = React.createRef();
    this.confirmPassword = React.createRef();
    this.newsLetter = React.createRef();
    this.terms = React.createRef();
  }

  matchPassword = () => {
    const { confirmPassword, password } = this;
    const element = document.getElementById('confirm_password');
    this.clearError();
    if (confirmPassword.current.value !== password.current.value) {
      element.classList.add('error');
      return false;
    }
    element.classList.remove('error');
    return true;
  }

  clearError = () => {
    const { error } = this.state;
    if (error) {
      this.setState({ error: '' });
    }
    const element = document.getElementById('registration_email');
    element.classList.remove('error');
    const element1 = document.getElementById('terms-text');
    element1.classList.remove('checkbox-error');
  }

  toggleDisable = () => {
    this.setState(({ disabled }) => ({ disabled: !disabled }));
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (this.matchPassword()) {
      const {
        email, password, newsLetter, toggleDisable, terms,
      } = this;
      if (!terms.current.checked) {
        const element = document.getElementById('terms-text');
        element.classList.add('checkbox-error');
        return;
      }
      toggleDisable();
      const { role, closeAllSidebars } = this.props;
      const data = {
        email: email.current.value,
        password: password.current.value,
        roles: [role],
        newsLetter: newsLetter.current.checked,
      };
      axios({
        method: 'post',
        url: API.register,
        data,
      })
        .then((res) => {
          setDelay(() => {
            const { token } = res.data;
            toggleDisable();
            if (token) {
              closeAllSidebars();
              setToken(token);
              Push(URL.auth + token);
            } else {
              this.setError(ERROR_MESSAGES.TRY_AGAIN);
            }
          });
        })
        .catch((err) => {
          setDelay(() => {
            const { data: resData } = err.response || {};
            const { type } = resData || {};
            this.setError(ERROR_MESSAGES[type] || ERROR_MESSAGES.TRY_AGAIN);
            if (type === ERROR_TYPES.EMAIL_ALREADY_USED) {
              const element = document.getElementById('registration_email');
              element.classList.add('error');
            }
            toggleDisable();
          });
        });
    }
  }

  setError = (error) => {
    this.setState({ error });
  }

  render() {
    const {
      forwardRef, toggleLoginSidebar, toggleRegistrationSidebar, active, role,
      closeAllSidebars,
    } = this.props;

    const { error, disabled } = this.state;
    const customMatchPassword = () => { this.matchPassword(); };
    return (
      <Sidebar
        forwardRef={forwardRef}
        active={active}
        toggleShow={toggleRegistrationSidebar}
      >
        <form onSubmit={this.onSubmit}>
          <h2 className="title">{SIGN_UP_SIDEBAR.TITLE}</h2>
          <div className="info">
            <label htmlFor="registration_email">
              <p>
                {SIGN_UP_SIDEBAR.INPUT.EMAIL}
                {error ? <span className="error-text">{` ${error}`}</span> : ''}
              </p>
              <input
                id="registration_email"
                type="email"
                pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                className="email"
                placeholder={SIGN_UP_SIDEBAR.PLACEHOLDER.EMAIL}
                onChange={this.clearError}
                ref={this.email}
                disabled={disabled}
                required
              />
            </label>
            <label htmlFor="registration_password">
              <p>{SIGN_UP_SIDEBAR.INPUT.PASSWORD}</p>
              <input
                id="registration_password"
                type="password"
                className="password"
                placeholder={SIGN_UP_SIDEBAR.PLACEHOLDER.PASSWORD}
                minLength={6}
                onChange={customMatchPassword}
                ref={this.password}
                disabled={disabled}
                required
              />
            </label>
            <label htmlFor="confirm_password">
              <p>{SIGN_UP_SIDEBAR.INPUT.CONFIRM_PASSWORD}</p>
              <input
                id="confirm_password"
                type="password"
                className="password"
                placeholder={SIGN_UP_SIDEBAR.PLACEHOLDER.CONFIRM_PASSWORD}
                minLength={6}
                onChange={customMatchPassword}
                ref={this.confirmPassword}
                disabled={disabled}
                required
              />
            </label>
            <label htmlFor="terms" className="label-with-checkbox">
              <Checkbox
                disabled={disabled}
                ref={this.terms}
                id="terms"
                onChange={this.clearError}
              />
              <div id="terms-text">
                {SIGN_UP_SIDEBAR.CHECKBOX.TERMS[0]}
                <Link to="/terms">{SIGN_UP_SIDEBAR.CHECKBOX.TERMS[1]}</Link>
                .
                {' *'}
              </div>
            </label>
            <label htmlFor="news" className="label-with-checkbox">
              <Checkbox
                id="news"
                ref={this.newsLetter}
                disabled={disabled}
              />
              <div>{SIGN_UP_SIDEBAR.CHECKBOX.NEWS}</div>
            </label>
          </div>
          <div className="bottom">
            <Button
              type="submit"
              buttonProps={{
                disabled,
                className: 'main-btn submit',
              }}
              loaderClassName="light-loader"
              label={<h5>{SIGN_UP_SIDEBAR.SIGN_UP_BUTTON}</h5>}
              loading={disabled}
            />
            <button
              className="transparent-btn"
              onClick={() => {
                toggleRegistrationSidebar(false);
                toggleLoginSidebar(true);
              }}
              type="button"
            >
              {SIGN_UP_SIDEBAR.SIGN_IN_BUTTON}
            </button>
          </div>
        </form>
        <SocialLogin
          signUp
          setError={this.setError}
          role={role}
          closeAllSidebars={closeAllSidebars}
        />
      </Sidebar>
    );
  }
}

RegistrationSidebar.propTypes = {
  toggleLoginSidebar: PropTypes.func.isRequired,
  toggleRegistrationSidebar: PropTypes.func.isRequired,
  closeAllSidebars: PropTypes.func.isRequired,
  forwardRef: PropTypes.instanceOf(Object).isRequired,
  active: PropTypes.bool.isRequired,
  role: PropTypes.string.isRequired,
};
export default RegistrationSidebar;
